import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Container, Typography, Button } from '@mui/material';
const useStyles = makeStyles()((theme) => ({
    section: {
        background: '#00ADF6',
    },
    container: {
        padding: theme.spacing(0, 7),
        [theme.breakpoints.down('md')]: {
            paddingBottom: theme.spacing(5),
        },
    },
    contentWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
        zIndex: 2,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse',
            textAlign: 'center',
        },
    },
    textBlock: {
        color: '#FFFFFF',
        maxWidth: '35%',
        [theme.breakpoints.down('md')]: {
            marginRight: 0,
            maxWidth: 400,
        },
    },
    heading: {
        fontSize: 48,
        fontWeight: 700,
        lineHeight: 1.2,
        marginTop: 0,
        [theme.breakpoints.down('md')]: {
            fontSize: 32,
        },
    },
    subtext: {
        fontSize: 16,
        lineHeight: 1.6,
        margin: theme.spacing(4, 0),
    },
    buttonsRow: {
        display: 'flex',
        gap: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    mobileScreenSection: {
        flex: '1 1 270px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        height: 480,
        [theme.breakpoints.down('md')]: {
            marginBottom: theme.spacing(4),
        },
    },
    appPromotion: {
        position: 'absolute',
        left: 'calc(100% - 585px)',
        width: 585,
        [theme.breakpoints.down('md')]: {
            width: 390,
            left: 'calc(50% - 225px)',
        },
    },
}));
const AppMobilePromotion = () => {
    const { classes } = useStyles();
    const openGooglePlayURL = () => {
        globalThis.open(process.env.REPEAT_APP_DOWNLOAD_GOOGLE_PLAY_URL, '_blank');
    };
    const openAppStoreURL = () => {
        globalThis.open(process.env.REPEAT_APP_DOWNLOAD_APP_STORE_URL, '_blank');
    };
    return (_jsx(Box, { className: classes.section, children: _jsx(Container, { className: classes.container, children: _jsxs(Box, { className: classes.contentWrapper, children: [_jsxs(Box, { className: classes.textBlock, children: [_jsx("h2", { className: classes.heading, children: "Available on mobile!" }), _jsx(Typography, { className: classes.subtext, children: "Repeat is now available on mobile, compete in tournaments, track your match results and claim prizes from anywhere" }), _jsxs(Box, { className: classes.buttonsRow, children: [_jsx(Button, { component: "a", "data-testid": "google-play-button", onClick: openGooglePlayURL, sx: { background: 'none', p: 0, minWidth: 0 }, children: _jsx("img", { src: "/img/mobile-app-promotions/google-play-badge.png", "data-testid": "google-play-badge", alt: "Get it on Google Play", height: "45" }) }), _jsx(Button, { component: "a", "data-testid": "app-store-button", onClick: openAppStoreURL, sx: { background: 'none', p: 0, minWidth: 0 }, children: _jsx("img", { src: "/img/mobile-app-promotions/app-store-badge.png", "data-testid": "app-store-badge", alt: "Download on the App Store", height: "45" }) })] })] }), _jsx(Box, { className: classes.mobileScreenSection, children: _jsx("img", { src: "/img/mobile-app-promotions/app-promotion.png", "data-testid": "app-promotion", alt: "App Promotion", className: classes.appPromotion }) })] }) }) }));
};
export default AppMobilePromotion;
